import { FC } from "react";
import Loading from "./Loading";

// --
// -- A dimming cover for content that is being refreshed in place.
// --
// -- For the second and later loads, where there is already something on
// -- screen: the plain spinner replaces content, which is right the first time
// -- and wrong afterwards - it would throw away the rows someone is reading and
// -- make the panel jump.
// --
// -- Deliberately blocks pointer events. Rows underneath belong to the previous
// -- query, and clicking one opens an order the reader did not mean to pick.
// -- The modal's own close button sits outside this, so it stays reachable.
// --
// -- The spinner is sticky rather than centred: over a long table, a centred
// -- one would sit below the fold, leaving a dimmed panel with no sign of why.
// --
const LoadingOverlay: FC<{ className?: string }> = ({ className = '' }) => (
  <div
    // aria-hidden because the wrapper carries aria-busy; announcing a
    // decorative spinner on top of that says nothing extra.
    aria-hidden="true"
    className={`absolute inset-0 z-10 bg-white/60 cursor-wait ${className}`}
  >
    <div className="sticky top-0 flex justify-center pt-8">
      <Loading />
    </div>
  </div>
);

export default LoadingOverlay;
